import { DateTime } from 'luxon';
import { GERMAN_TIMEZONE, LATE_BOOKING_HOUR } from '../../constants';
import { TRANSFER } from '../../booking/models/transfer';
import { nowInGermany } from './serverClock';

// Payment-link gate: booked at or after LATE_BOOKING_HOUR (Munich) for a trip today or
// tomorrow -> no online payment link, the office handles payment.
const checkOrderLate = (now) => now.hour >= LATE_BOOKING_HOUR;

const checkBookingNextDay = (dateTime, now) => dateTime <= now.plus({ days: 1 }).endOf('day');

const checkShortTermTransfer = (transfer) => {
    let bookingDateTime;

    switch (transfer.typeId) {
        case TRANSFER.TO_MUNICH:
        case TRANSFER.TO_NUREMBERG:
            bookingDateTime = DateTime.fromISO(transfer.flight.date + 'T' + transfer.arrivalTime, {
                zone: GERMAN_TIMEZONE,
            });
            break;

        case TRANSFER.FROM_MUNICH:
        case TRANSFER.FROM_NUREMBERG:
            bookingDateTime = DateTime.fromISO(transfer.flight.date + 'T' + transfer.flight.time, {
                zone: GERMAN_TIMEZONE,
            });
            break;

        case TRANSFER.SPECIAL:
            bookingDateTime = DateTime.fromISO(transfer.tripDate + 'T' + transfer.tripTime, { zone: GERMAN_TIMEZONE });
            break;

        default:
            return false;
    }

    const now = nowInGermany();
    return checkOrderLate(now) && checkBookingNextDay(bookingDateTime, now);
};

// check if booking is short term
const checkShortTermBooking = (transfers) => {
    return transfers.filter(Boolean).some(checkShortTermTransfer);
};

export { checkShortTermBooking };
